<!--
 * @Author: DY
 * @Date: 2024-11-20 18:46:12
 * @LastEditTime: 2026-06-01 11:48:23
 * @Description: 退库入库审核表单【仓储管理-退库入库审核】
 * @FilePath: \ShiMo_Mobile\src\views\storage\instockReturnApproval\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="instockReturnApprovalForm commonFormStyles">
            <HeaderNav header-title="入库单" left-icon-name="2" right-icon-name="3" v-if="!isNews" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <van-tabs class="currencyTabsStyle" v-model="tabActive">
                <van-tab title="退库入库信息表" name="1">
                    <ul class="formList" :class="{'formList_Readonly' : isReadonly}">
                        <li>
                            <van-field
                                disabled
                                label="退库入库编号"
                                :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                v-model="formData.InstockNumber"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                readonly
                                label="来源单据编号"
                                :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                v-model="formData.OutstockNumber"
                                @click="selectSource"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="申请人"
                                :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                v-model="formData.ApplyUserName"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="申请时间"
                                :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                v-model="formData.ApplyTime"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                readonly
                                label="仓库名称"
                                :disabled="isReadonly"
                                :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                v-model="formData.StockName"
                                @click="selectWarehouse"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="库管员"
                                :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                v-model="formData.StoremanName"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="状态"
                                :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                                v-model="formData.StatusName"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="入库时间"
                                :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                v-model="formData.InstockTime"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                label="备注"
                                type="textarea"
                                :rows="2"
                                :readonly="!isRemarks"
                                :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                v-model="formData.Remarks"
                                placeholder="库管员填写意见"
                            ></van-field>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="退库入库信息表" name="2">
                    <van-form validate-first class="form_">
                        <div class="info_box">
                            <div class="head_box">
                                退库入库明细表
                                <van-icon
                                    name="add"
                                    v-if="listType !== 3"
                                    class="add_icon"
                                    @click="addDetailFun(1)"
                                ></van-icon>
                            </div>
                            <div class="items" v-if="formData.Materials.length > 0">
                                <div class="list_item" v-for="(item, index) in formData.Materials" :key="index">
                                    <p class="title">
                                        <span>
                                            <van-icon
                                                name="clear"
                                                v-if="listType !== 3"
                                                class="add_icon"
                                                @click="delDetailFun(item.Id)"
                                            ></van-icon>
                                            <span>物料代码：{{ item.MaterialCode }}</span>
                                        </span>
                                    </p>
                                    <div class="ps_box" v-if="listType !== 3">
                                        <div class="ps_box_item">
                                            <div class="list_item_card list_item_card1 list_item_card2">
                                                <h5>短描述：</h5>
                                                <van-field v-model="item.MaterialShortName" label-align="right" disabled></van-field>
                                            </div>
                                            <div class="list_item_card list_item_card1">
                                                <h5>长描述：</h5>
                                                <van-field v-model="item.MaterialName" label-align="right" disabled></van-field>
                                            </div>
                                        </div>
                                        <div class="ps_box_item">
                                            <div class="list_item_card list_item_card1 list_item_card2">
                                                <h5>退库入库数量：</h5>
                                                <van-field v-model="item.VolumeApply" label-align="right" :disabled="isReadonly"></van-field>
                                            </div>
                                            <div class="list_item_card list_item_card1">
                                                <h5>单位：</h5>
                                                <van-field v-model="item.Unit" label-align="right" disabled></van-field>
                                            </div>
                                        </div>
                                        <template v-if="listType == 3">
                                            <div class="ps_box_item">
                                                <div class="list_item_card list_item_card1 list_item_card2">
                                                    <h5>实际入库数量：</h5>
                                                    <van-field v-model="item.VolumeActual" label-align="right" disabled></van-field>
                                                </div>
                                                <div class="list_item_card list_item_card1">
                                                    <h5>存放位置：</h5>
                                                    <van-field v-model="item.GridName" label-align="right" disabled></van-field>
                                                </div>
                                            </div>
                                            <div class="ps_box_item">
                                                <div class="list_item_card list_item_card1 list_item_card2">
                                                    <h5>入库前库存：</h5>
                                                    <van-field v-model="item.BeforeVolume" label-align="right" disabled></van-field>
                                                </div>
                                                <div class="list_item_card list_item_card1">
                                                    <h5>入库后库存：</h5>
                                                    <van-field v-model="item.AfterVolume" label-align="right" disabled></van-field>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="ps_box" v-else>
                                        <div class="list_item_card list_item_card3">
                                            <van-field
                                                label="短描述"
                                                :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                                input-align="right"
                                                v-model="item.MaterialShortName"
                                                readonly
                                            ></van-field>
                                            <van-field
                                                label="长描述"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                v-model="item.MaterialName"
                                                readonly
                                            ></van-field>
                                            <van-field
                                                label="退库入库数量"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                v-model="item.VolumeApply"
                                                readonly
                                            ></van-field>
                                            <van-field
                                                label="单位"
                                                :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                input-align="right"
                                                v-model="item.Unit"
                                                readonly
                                            ></van-field>
                                        </div>
                                        <div v-for="(dat, k) in item.Grids" :key="`grids_${k}`" style="width: 100%;">
                                            <div class="list_item_card list_item_card3">
                                                <van-field
                                                    label="存放位置"
                                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                                    input-align="right"
                                                    v-model="dat.GridCode"
                                                >
                                                    <template #label>
                                                        <span>存放位置</span>
                                                        <button class="qr_btn" @click="addCfFun(item)">
                                                            拆分
                                                        </button>
                                                        <button class="qr_btn" v-if="dat.isNew" @click="deleteCfFun(item, k)">
                                                            删除
                                                        </button>
                                                    </template>
                                                </van-field>
                                            </div>
                                            <div style="display: flex;" v-if="dat.GridId">
                                                <div class="list_item_card list_item_card1 list_item_card2">
                                                    <div class="num_label">
                                                        实际入库量：
                                                    </div>
                                                    <div>
                                                        <van-field v-model="dat.VolumeActual" label-align="right" @change="VolumeActualFun"></van-field>
                                                    </div>
                                                </div>
                                                <div class="list_item_card list_item_card1">
                                                    <div class="num_label">
                                                        入库前库存：
                                                    </div>
                                                    <div>
                                                        <van-field v-model="dat.BeforeVolume" label-align="right" readonly></van-field>
                                                    </div>
                                                </div>
                                                <div class="list_item_card list_item_card1">
                                                    <div class="num_label">
                                                        入库后库存：
                                                    </div>
                                                    <div>
                                                        <van-field v-model="dat.AfterVolume" label-align="right" readonly></van-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-form>
                </van-tab>
            </van-tabs>
            <footer class="currencyFooterStyle btns">
                <template v-if="!btnIsView && !isReadonly">
                    <button v-if="listType !== 3" class="confirm" @click="saveFun(1)">
                        提交
                    </button>
                    <button v-if="listType === 3" class="confirm" @click="affirmFun">
                        确认
                    </button>
                    <button v-if="listType === 2 || listType === 3" class="confirm" @click="backFun">
                        退回
                    </button>
                    <button class="confirm" @click="saveFun(0)">
                        保存
                    </button>
                </template>
                <template v-if="!isNews">
                    <van-button type="primary" loading-type="spinner" @click="closeAllocationForm">
                        关闭
                    </van-button>
                </template>
            </footer>
            <van-popup v-model="showCenter" round :style="{ width: '90%', height: '80%' }">
                <van-form validate-first class="form_2">
                    <div class="items2">
                        <div class="list_item" v-for="(item, index) in seleMaterials" :key="index">
                            <p class="title">
                                <van-checkbox
                                    v-model="item.check"
                                    :name="item.grid_id"
                                    checked-color="#ee0a24"
                                    shape="square"
                                    @click="selChangeFun(item)"
                                >
                                    {{ item.material_code }}
                                </van-checkbox>
                            </p>
                            <div class="ps_box">
                                <div class="ps_box_item">
                                    <div class="list_item_card list_item_card1 list_item_card2">
                                        <h5>短描述：</h5>
                                        <van-field disabled v-model="item.material_short_name" label-align="right"></van-field>
                                    </div>
                                    <div class="list_item_card list_item_card1">
                                        <h5>长描述：</h5>
                                        <van-field disabled v-model="item.material_name" label-align="right"></van-field>
                                    </div>
                                </div>
                                <div class="ps_box_item">
                                    <div class="list_item_card list_item_card1 list_item_card2">
                                        <h5>出库数量：</h5>
                                        <van-field disabled v-model="item.volume_outstock" label-align="right"></van-field>
                                    </div>
                                    <div class="list_item_card list_item_card1">
                                        <h5>单位：</h5>
                                        <van-field disabled v-model="item.unit" label-align="right"></van-field>
                                    </div>
                                </div>
                                <div class="ps_box_item">
                                    <div class="list_item_card list_item_card1 list_item_card2">
                                        <h5>出库时间：</h5>
                                        <van-field disabled v-model="item.outstock_time" label-align="right"></van-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="currencyFooterStyle prop_btns">
                        <button class="confirm" @click="seleSave">
                            确认
                        </button>
                    </div>
                </van-form>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { mixin_MessageJump } from '@/assets/mixin/mixin_MessageJump';
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'instock-return-approval-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/instockReturnApproval') {
            this.$store.commit('noKeepAlive', 'instock-return-approval-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    mixins: [mixin_MessageJump],
    props: {},
    data() {
        return {
            isNews: false,
            isSelect: false,
            showCenter: false,
            isReadonly: false,
            isRemarks: false,
            btnIsView: false,
            listType: 1,
            selectType: 1,
            formData: {
                Id: '',
                InstockNumber: '',
                OutstockNumber: '',
                ApplyUserName: '',
                ApplyTime: '',
                StockName: '',
                StoremanName: '',
                InstockTime: '',
                Remarks: '',
                Status: 0,
                Materials: [],
            },
            status: '',
            tabActive: '1',
            seleMaterials: [],
            Materials: [],
            openCfDat: {},
            saveId: null,
            StatusData: [
                {
                    name: '待提交',
                    value: 0,
                },
                {
                    name: '待审核',
                    value: 1,
                },
                {
                    name: '待入库',
                    value: 2,
                },
                {
                    name: '已入库',
                    value: 3,
                },
                {
                    name: '已作废',
                    value: 4,
                },
            ],
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.warehouseData) {
            this.formData.StockCode = this.$route.params.warehouseData[0].stock_code;
            this.formData.StockId = this.$route.params.warehouseData[0].id;
            this.formData.StockName = this.$route.params.warehouseData[0].stock_name;
            this.formData.StoremanName = this.$route.params.warehouseData[0].storeman_name;
            this.formData.ApplyTime = this.$route.params.warehouseData[0].creation_time;
            this.formData.StoremanId = this.$route.params.warehouseData[0].storeman_id;
        }
        if (this.$route.params.chooseData) {
            this.formData.StockCode = this.$route.params.chooseData[0].stock_code;
            this.formData.StockId = this.$route.params.chooseData[0].stock_id;
            this.formData.StockName = this.$route.params.chooseData[0].stock_name;
            this.formData.StoremanName = this.$route.params.chooseData[0].storeman_name;
            this.formData.ApplyTime = this.$route.params.chooseData[0].creation_time;
            this.formData.StoremanId = this.$route.params.chooseData[0].storeman_id;
            this.formData.OutstockNumber = this.$route.params.chooseData[0].outstock_number;
            this.formData = JSON.parse(JSON.stringify(this.formData));
        }
        if (this.$route.params.cfData) {
            this.formData.Materials.forEach(item => {
                if (item.Id === this.openCfDat.Id) {
                    item.Grids = item.Grids.filter(v => { return v.GridId; });
                    const ids = item.Grids.map(v => { return item.GridId; });
                    this.$route.params.cfData.forEach(dat => {
                        if (!ids.includes(dat.GridId)) {
                            item.Grids.push({
                                isNew: true,
                                GridCode: dat.grid_code,
                                GridId: dat.grid_id,
                                GridName: dat.grid_name,
                                BeforeVolume: dat.before_volume || 0,
                                VolumeActual: dat.VolumeActual || 0,
                            });
                        }
                    });
                }
            });
        }
        this.isSelect = false;
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        splitFun() {
            this.isSelect = true;
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectTable',
                params: {
                    newsToken: this.newsToken,
                    sourcePath: 'instockReturnApprovalForm',
                    requestUrl: '/basicplatform/tabledata',
                    callbackDataKey: 'warehouseData',
                    relationKey: 'id',
                    pageSize: 9999,
                    requestType: 'post',
                    listCode: 'choose_grid_only',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    isZero: true,
                    type: 'radio',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                    }],
                },
            });
        },
        selChangeFun(row) {
            this.seleMaterials = JSON.parse(JSON.stringify(this.seleMaterials));
        },
        async saveFun(type) {
            let msg = '';
            let url = '';
            let saveVal = 0;
            let submitVal = 0;
            if (this.listType === 1) {
                url = '/interfaceApi/procurement/instock_return/instock_apply_save';
                saveVal = 0;
                submitVal = 1;
            } else if (this.listType === 2) {
                saveVal = 1;
                submitVal = 2;
                url = '/interfaceApi/procurement/instock_return/instock_manager_save';
            } else if (this.listType === 3) {
                saveVal = 2;
                submitVal = 3;
                url = `/interfaceApi/procurement/instock_return/instock_storeman_save?instockId=${this.saveId}&status=${type === 0 ? 2 : 3}`;
            }
            if (type === 0) {
                msg = '保存成功！';
                this.formData.Status = saveVal;
            } else if (type === 1) {
                msg = '提交成功！';
                this.formData.Status = submitVal;
            }
            const res = await this.saveApiData(url, this.formData);
            if (res) {
                this.$toast(msg);
                if (type === 1) {
                    this.closeAllocationForm();
                }
            }
        },
        async affirmFun() {
            this.$dialog.confirm({
                message: '确认要入库吗?',
            }).then(async () => {
                this.formData.Status = 3;
                const url = '/interfaceApi/procurement/instock_return/instock_storeman_save';
                const res = await this.saveApiData(url, this.formData);
                if (res) {
                    this.$toast('入库成功！');
                    this.closeAllocationForm();
                }
            }).catch(() => {
                return;
            });
        },
        async backFun() {
            let url = '';
            if (this.listType === 2) {
                url = `/interfaceApi/procurement/instock_return/instock_manager_sendback?id=${this.$route.params.data.id}`;
            } else if (this.listType === 3) {
                url = `/interfaceApi/procurement/instock_return/instock_storeman_sendback?id=${this.$route.params.data.id}`;
            }
            const res = await this.backApiData(url);
            if (res) {
                this.$toast('退回成功！');
                this.closeAllocationForm();
            }
        },
        // 退回
        backApiData(url) {
            return this.$axios.$get(url, { token: this.newsToken });
        },
        // 保存申请数据
        saveApiData(url, requestData) {
            let data = requestData;
            if (this.listType === 3) {
                const dat = this.setDetailData();
                data = {
                    Id: dat.Id,
                    Status: dat.Status,
                    Remarks: dat.Remarks,
                    Materials: dat.Materials,
                };
            }
            return this.$axios.$post(url, data, { token: this.newsToken });
        },
        setDetailData() {
            const arr = [];
            const dat = JSON.parse(JSON.stringify(this.formData));
            this.Materials.forEach(item => {
                arr.push({
                    Id: item.Id,
                    MaterialCode: item.MaterialCode,
                    MaterialName: item.MaterialName,
                    MaterialShortName: item.MaterialShortName,
                    Unit: item.Unit,
                    VolumeActual: item.VolumeActual,
                    VolumeApply: item.VolumeApply,
                    Grids: item.Grids,
                });
            });
            dat.Materials = arr;
            return dat;
        },
        seleSave() {
            if (this.selectType === 1) {
                const items = [];
                this.seleMaterials.forEach(item => {
                    if (item.check) {
                        items.push({
                            Grids: [],
                            Id: item.grid_id,
                            MaterialCode: item.material_code,
                            MaterialName: item.material_name,
                            GridName: item.grid_name,
                            MaterialShortName: item.material_short_name,
                            Unit: item.unit,
                            VolumeApply: 0,
                            AfterVolume: 0,
                            BeforeVolume: 0,
                            VolumeActual: 0,
                        });
                    }
                });

                const ids = this.formData.Materials.map(item => { return item.id; });
                items.forEach(item => {
                    if (!ids.includes(item.id)) {
                        this.formData.Materials.push(item);
                    }
                });
            } else {
                // this.formData.Materials.forEach(item => {
                //     if (item.Grids) {
                //         item.Grids = item.Grids.filter(v => { return v.GridId; });
                //         item.Grids.push({
                //             AfterVolume: 0,
                //             BeforeVolume: item.before_volume,
                //             GridCode: item.grid_code,
                //             GridId: item.grid_id,
                //             GridName: item.grid_name,
                //             VolumeActual: item.volume,
                //         });
                //     }
                // });
            }

            this.showCenter = false;
        },
        delDetailFun(id) {
            if (this.isReadonly) { return; }
            this.formData.Materials = this.formData.Materials.filter(item => { return item.Id !== id; });
        },
        async addDetailFun(type, item) {
            if (this.isReadonly) { return; }
            if (type === 1 && !this.formData.OutstockNumber) {
                this.$toast('请先选择来源单据编号！');
                return;
            }
            this.selectType = type;
            const res = await this.getSeleData(type, item);
            this.seleMaterials = res.rows;
            this.seleMaterials.forEach(item => {
                item.check = false;
            });
            this.showCenter = true;
        },
        // 右划回退
        swiperright() {
            if (!this.isNews) {
                this.$router.isBack = 1;
                this.$router.go(-1);
            }
        },

        async initpage() {
            this.isNews = this.$route.params.isNews || false;
            if (this.isNews && this.$route.params.data.tenant_id) {
                // 有tenant_id，消息列表跳转办理页面，判断多租户
                await this.getNewsToken(this.$route.params.data.tenant_id);
            }
            this.listType = this.$route.params.listType || 1;
            if (this.isNews) {
                this.listType = this.$route.params.data.listType;
            }
            if (this.$route.params.type === 'see') {
                this.isReadonly = true;
            } else {
                this.isReadonly = false;
            }
            if (this.$route.params?.data) {
                this.saveId = this.$route.params.data.id;
                this.isEdit = true;
                this.formData = await this.getApplyData(this.saveId);
                this.formData.Materials.forEach(item => {
                    if (!item.Grids || !item.Grids[0]) {
                        item.Grids = [{
                            AfterVolume: 3,
                            BeforeVolume: 0,
                            GridCode: '',
                            GridId: '',
                            GridName: '',
                            VolumeActual: 0,
                        }];
                    }
                });
                this.Materials = this.formData.Materials;
                this.setMaterialsData();
                this.VolumeActualFun();
                this.isRemarks = false;
                if (this.listType === 1) {
                    if (this.formData.Status !== 0) {
                        this.btnIsView = true;
                    }
                } else if (this.listType === 2) {
                    if (this.formData.Status !== 1) {
                        this.btnIsView = true;
                    }
                } else if (this.listType === 3) {
                    this.isRemarks = true;
                }
                this.formData.StatusName = this.StatusData.filter(item => { return item.value === this.formData.Status; })[0].name;
            } else {
                this.formData = {
                    Id: '',
                    InstockNumber: '',
                    OutstockNumber: '',
                    ApplyUserName: this.$takeTokenParameters('Name'),
                    ApplyTime: '',
                    StockName: '',
                    StoremanName: '',
                    InstockTime: '',
                    Remarks: '',
                    Status: 0,
                    StatusName: '待提交',
                    Materials: [],
                };
                this.saveId = null;
                this.isRemarks = false;
            }
            this.Materials = this.formData.Materials;
        },
        setMaterialsData() {
            const arr = [];
            this.Materials.forEach(item => {
                if (item.Grids.length === 0) {
                    arr.push(item);
                }
                item.Grids.forEach(dat => {
                    this.formData.Materials.forEach(val => {
                        if (val.grid_id === dat.grid_id) {
                            val.VolumeActual = dat.VolumeActual;
                        }
                    });
                    arr.push({ ...item, ...dat, parentId: item.Id });
                });
            });
            this.formData.Materials = arr;
            this.VolumeActualFun();
        },
        VolumeActualFun() {
            this.formData.Materials.forEach(item => {
                if (item.Grids) {
                    item.Grids.forEach(v => {
                        v.VolumeActual = (v.VolumeActual || 0) * 1;
                        v.BeforeVolume = (v.BeforeVolume || 0) * 1;
                        v.AfterVolume = v.VolumeActual + v.BeforeVolume;
                    });
                }
            });
            this.formData = JSON.parse(JSON.stringify(this.formData));
        },

        // 选择仓库
        selectWarehouse() {
            if (this.isReadonly || this.listType === 3) { return; }
            this.isSelect = true;
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    newsToken: this.newsToken,
                    pageTitle: '选择仓库',
                    sourcePath: 'instockReturnApprovalForm',
                    listCode: 'choose_stock_only',
                    callbackDataKey: 'warehouseData',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '仓库类别',
                        code: 'stock_category_name',
                        icon: 'icon_13@2x',
                    }, {
                        name: '主要存放',
                        code: 'main_storage',
                        icon: 'icon_32@2x',
                    }, {
                        name: '管理单位',
                        code: 'manage_org_name',
                        icon: 'icon_4@2x',
                    }, {
                        name: '管理部门',
                        code: 'manage_dept_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '仓库保管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },
        // 选择来源单
        selectSource() {
            if (this.isReadonly || this.listType === 3) { return; }
            this.isSelect = true;
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    newsToken: this.newsToken,
                    pageTitle: '选择来源单据',
                    sourcePath: 'instockReturnApprovalForm',
                    listCode: 'choose_outstock',
                    callbackDataKey: 'chooseData',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '出库单号',
                        code: 'outstock_number',
                        isTitle: true,
                    }, {
                        name: '仓库编号',
                        code: 'stock_code',
                        icon: 'icon_34@2x',
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '仓库保管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },
        // 选择拆分物料
        addCfFun(item) {
            if (this.isReadonly) { return; }
            this.isSelect = true;
            this.openCfDat = item;
            this.$router.isBack = 2;
            const gridId = item.Grids.map(k => k.GridId).toString();
            this.$router.replace({
                name: 'selectTable',
                params: {
                    newsToken: this.newsToken,
                    sourcePath: 'instockReturnApprovalForm',
                    requestUrl: `/basicplatform/tabledata?stock_id=${this.formData.StockId}&material_code=${item.MaterialCode}&grid_id=${gridId}`,
                    callbackDataKey: 'cfData',
                    relationKey: 'grid_id',
                    pageSize: 9999,
                    requestType: 'post',
                    listCode: 'choose_grid_only',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    isZero: true,
                    type: 'radio',
                    headerList: [{
                        name: '仓库编号',
                        code: 'grid_code',
                    }, {
                        name: '仓库名称',
                        code: 'grid_name',
                    }],
                },
            });
        },

        deleteCfFun(item, index) {
            item.Grids.splice(index, 1);
        },

        closeAllocationForm() {
            if (!this.isNews) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'instockReturnApply',
                    params: {
                        saveCallback: true,
                    },
                });
            } else {
                this.isReadonly = true;
            }
        },

        getformDataRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/instock_material/instock_material_single?id=${id}`, { token: this.newsToken });
        },

        formOperationRequrst(formData) {
            return this.$axios.$post('/interfaceApi/procurement/instock_material/instock_material_save', formData, { token: this.newsToken });
        },
        // 获取详情
        getApplyData(id = '3a15ace9-929d-6bca-2340-51ade519ca1b') {
            return this.$axios.$get(`/interfaceApi/procurement/instock_return/instock_single?id=${id}`, { token: this.newsToken });
        },
        // 获取详情
        getSeleData(type, row) {
            // 列表数据请求地址
            const paramVal = type === 1 ? `?outstock_number=${this.formData.OutstockNumber}` : `?stock_id=${this.formData.StockId}&material_code=${row.MaterialCode}`;
            const postUrl = `/interfaceApi/basicplatform/tabledata${paramVal}`;
            const cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
            const params = {
                cacheKey,
                code: type === 1 ? 'choose_outstock_material' : 'choose_grid_only',
                customsort: '',
                limit: 100,
                page: 0,
            };
            return this.$axios.$post(postUrl, params, { token: this.newsToken });
        },

    },
};
</script>
<style lang="stylus">
.instockReturnApprovalForm
    background: #f0f0f0;
    .currencyTabsStyle
        flex 1
        height 0
    .qr_btn
        font-size 10rpx
        padding 0 5rpx
        margin-left 10rpx
        background #fcebec
        border 1px solid #f8c7c9
        color #E93743
        border-radius 2rpx
    .num_label
        font-size 12rpx
        margin-bottom 2rpx
    .info_box
        border-radius 4rpx
        background: #fff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
    .formList
        &.formList_Readonly
            height calc(100% - 44rpx)
    .form_
        padding 12rpx
        height: 100%
    .add_icon
        margin-right 10rpx
        font-size 18rpx
        line-height 20rpx
        width 20rpx
        height 20rpx
    .form_2
        height: 100%
    .items
        padding 10rpx
        height calc(100% - 40rpx)
        overflow-y: auto;
    .items2
        padding 15rpx
        height calc(100% - 60rpx)
        overflow-y: auto;
    .van-cell__right-icon
        color #666
    .head_box
        background: linear-gradient(to bottom, #fff4f2, #fff);
        height 40rpx
        line-height 40rpx
        border-radius 5rpx
        padding-left 15rpx
        color #E93543
        font-weight: 550;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0
    .list_item
        overflow hidden
        background #fff
        box-shadow: 0px 0px 3px 0px #b5b5b5;
        border-radius: 4rpx;
        position relative
        margin-bottom 10rpx
        &:last-child
            margin-bottom 0
        .title
            width 100%
            height 42rpx
            background #F8F8F8
            margin-bottom 0 !important
            display flex
            align-items center
            padding 0 10rpx
            font-size 16rpx
            position relative
            display: flex;
            justify-content: space-between;
            >span
                color: #e93743
                display: flex;
                justify-content: center;
                align-items: center;
            .btn
                position absolute
                top 0
                right 0
                color #fff !important
                font-size 13rpx !important
                background: #f86565;
                padding 2rpx 5rpx
                border-radius: 0 8rpx
                font-weight: 500 !important;
                &.btn_ok
                    background #ccc !important
    .ps_box
        display: flex
        flex-wrap: wrap;
        .van-cell
            display: flex;
            align-items: center;
        .ps_box_item
            width 100%
            display flex
            margin-top 8rpx
            &:last-child
                margin-bottom 10rpx
            .list_item_card
                width calc(50% - 2rpx)
            h5
                font-size 14rpx
                margin-bottom 5rpx
        .list_item_card1
            padding 0 10rpx
            .van-cell__title
                display none
            .van-cell
                padding: 5px 8px;
                border: 1px solid #ADC7E0;
                background #FAFBFE
                border-radius 4px
                &.van-field--disabled
                    background: #f8f8f8;
                    border-color: #d7d7d7;
                    color: rgba(98, 98, 98, 0.7);
                input
                    width 100%
        .list_item_card2
            margin-right 0rpx
            margin-bottom 10rpx
        .list_item_card3
            width 100%
            border-top: 1px solid #efefef;
            .van-cell__title
                white-space: nowrap;
                width 50%
// >>>.van-button--plain.van-button--danger
//     background: #fcebec;
//     width: 60rpx;
//     height 25rpx
//     position absolute
//     bottom 25rpx
//     right 10rpx
// .btns
//     width 100%
//     position absolute
//     left 0
//     bottom 0
// .prop_btns
//     width: 100%
//     height 60rpx
//     background #fff
//     button
//         flex 0.8
</style>
